import { ReportParams } from '../types';

interface ProcessedParams {
    opt: any;
    p: string[];
}

// 处理业务线参数
const bizLineMap = {
    to_B: 'job_business_speed',
    job_business_speed: 'job_business_speed',
    to_C: 'job',
    job: 'job'
};

export function processReportParams(reportParams: ReportParams): ProcessedParams {
    const { pageType, actionType, extJson = {}, options = {} } = reportParams || {};

    if (!pageType) {
        console.log(
            '【zp-weblog】无线埋点上报异常：缺少必填参数pageType，参考文档：https://igit.58corp.com/hrg-fe/zhaopin-qy-utils/zp-weblog'
        );
        return { opt: null, p: [] };
    }

    if (!actionType) {
        console.log(
            '【zp-weblog】无线埋点上报异常：缺少必填参数actionType，参考文档：https://igit.58corp.com/hrg-fe/zhaopin-qy-utils/zp-weblog'
        );
        return { opt: null, p: [] };
    }

    // 处理业务线参数
    const bizLine = bizLineMap[options['bizLine']];
    if (!bizLine) {
        console.log(
            '【zp-weblog】无线埋点上报异常：缺少必填参数bizLine，参考文档：https://igit.58corp.com/hrg-fe/zhaopin-qy-utils/zp-weblog'
        );
        return { opt: null, p: [] };
    }

    const params: string[] = [JSON.stringify(extJson)];

    const optKeys = Object.keys(options);
    const opt: any = {
        page_type: pageType,
        action_type: actionType,
        realtime: optKeys.indexOf('realtime') ? Boolean(options.realtime) : false,
        top_level: optKeys.indexOf('top_level') ? Boolean(options.top_level) : false,
        cate: options.cate || '9224',
        bizLine,
        json: {
            url: window.location.href,
            referer: document.referrer,
            ...extJson
        },
        params
    };

    return { opt, p: params };
}
